import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ToolsService } from 'src/app/services/tools.service';
import { ProductsService } from 'src/app/services/products.service';
import { ConfigService } from 'src/app/services/config.service';
import { AuthService } from 'src/app/services/auth.service';
import { ModalRedeemCouponPage } from 'src/app/modals/modal-redeem-coupon/modal-redeem-coupon.page';
import { ModalRedeemInsurancePage } from 'src/app/modals/modal-redeem-insurance/modal-redeem-insurance.page';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
})
export class ProductComponent implements OnInit {
  @Input() product

  is_insurance = false
  quantity = 1
  allow_payment = false
  money = 0
  points = 0
  rangeValue =  0;
  maxRangeValue = 0
  minRangeValue = 0

  constructor(
    public router: Router,
    public toolsService: ToolsService,
    public authService: AuthService,
    public productsService: ProductsService,
    public configService: ConfigService,
    public modalController: ModalController
  ) { }

  ngOnInit() {
    this.is_insurance = this.product.is_insurance
    this.loadPaymentOptions()
  }

  getProductCurrentPrice(product){
    return product.price - product.discount
  }

  loadPaymentOptions(){
    if(!this.authService.isLogged){
      return
    }
    var points_aux = this.product.price - this.product.discount
    if(this.authService.player_initial_data.points >= points_aux){
      this.rangeValue = this.getProductCurrentPrice(this.product)
      this.points = this.getProductCurrentPrice(this.product)
    }
    else {
      this.points = this.authService.player_initial_data.points
      let difference = this.getProductCurrentPrice(this.product) - this.points
      this.money = difference * this.configService.company_info.currency_value
      this.rangeValue = this.authService.player_initial_data.points
    }
    this.maxRangeValue = this.rangeValue
    this.minRangeValue = this.productsService.validateMaxMoneyValue(this.getProductCurrentPrice(this.product))

    if (this.minRangeValue > this.maxRangeValue){
      this.rangeValue = this.minRangeValue
      this.maxRangeValue =  this.getProductCurrentPrice(this.product)
    }
  }

  async changeLikedState(){
    if(this.authService.isLogged){
      try{
        this.productsService.changeLikedState(this.product.id);
        this.product.liked = !this.product.liked
      }catch(error){
        this.toolsService.showErrorToast()
        console.error('[PRODUCT-COMPONENT] changeLikedState()', error)
      }
    }
    else
      this.toolsService.showErrorToast("Debes ingresar para hacer esto")
  }

  openProductDetail(){
    this.router.navigate(['/producto/' + this.product.id])
  }

  isInShoopingCart(){
    var item = this.productsService.shooping_cart.find(item => item.id == this.product.id);
    return item;
  }
  

  async presentReedemCouponModal(){
    const modal = await this.modalController.create({
      component: ModalRedeemCouponPage,
      componentProps: {
        product: this.product
      }
    });
    modal.onDidDismiss()
    .then((response) => {
      if(response.data){
        this.product.additional_info = response.data;
        this.addProductShoopingCart();
      }
  });
    return await modal.present();
  }

  // Function to check if category is digital coupons
  async checkCategory(){
    this.product = await this.productsService.getProductDetail(this.product.id);
    this.product.allow_payment = false;
    if(!this.productsService.validateNumberOfProducts(this.product, this.quantity)){
      this.toolsService.showErrorToast("No puedes agregar más de 10 productos al carrito")
      return
    }
    if(this.authService.isLogged){
      console.log(this.product)
      if(!this.product.allow_payment){
        this.money = 0;
      }
      this.product = this.productsService.normaliseProduct(this.product, this.allow_payment, this.money, this.points, this.rangeValue, this.maxRangeValue, this.minRangeValue)
      if(this.product.brand_id || this.product.mega_coupon) // it is coupon
        this.presentReedemCouponModal()
      else if (this.is_insurance) // it is busqo insurance
        this.presentReedemInsuranceModal()
      else
        this.addProductShoopingCart()
    }
    else
      this.toolsService.showErrorToast("Debes ingresar para agregar un producto al carrito")
  }


  addProductShoopingCart(){
    if(this.product.coupon_used){
      // Validation coupon is not already used
      var coupon_exists = this.productsService.shooping_cart.find(item => item.coupon_used && item.coupon_used == this.product.coupon_used)
      if(coupon_exists){
        this.toolsService.showErrorToast("Ya estás usando este cupón en tu carrito")
        return
      }
    } 
    this.toolsService.showSuccessToast('Producto agregado al carrito')
    this.product['quantity'] = this.quantity;
    if (!this.product.allow_payment) {
      this.product.purchase.points = this.product.price;
      this.product.purchase.money = 0;
      this.product.purchase.rangeValue = 0;
    }
    this.productsService.addProduct(this.product);
  }

  removeProductShoopingCart(){
    this.productsService.removeProduct(this.product.id);
  }

  goToShoppingCart(){
    this.router.navigate(['/carrito-de-compras/'])
  }

  displayDisc(discount_value){
    try{
      return discount_value.indexOf('Dcto') >  -1
    }
    catch(e){
      return false
    }

  }

  displayDateInDays(end_date: string){
    return this.toolsService.displayDateInDays(end_date);
  }

  async presentReedemInsuranceModal() {
    const modal = await this.modalController.create({
      component: ModalRedeemInsurancePage,
      componentProps: {
        product: this.product
      }
    });
    modal.onDidDismiss()
      .then((response) => {
        if (response.data) {
          this.product.additional_info = response.data.additional_info;
          this.product.price = response.data.product.price; 
          this.product.custom_price_cash = response.data.product.custom_price_cash; 
          this.product.discount = response.data.product.discount
          this.addProductShoopingCart();
        }
      });
    return await modal.present();
  }
}
